import Rules from '@/app/utils/toolkit/business-rules/pension-payment-instruction/rules.json';

export const accountTypes = {
  ACCUMULATION: [
    {
      label: 'Accumulation Account',
    },
  ],
  PENSION: [
    {
      label: 'Retirement Phase Pension (Account-based)',
    },
    {
      label: 'Retirement Phase Pension (Not account-based)',
    },
  ],
};

export const paymentInstructionMatrix = {
  ACCUMULATION: Rules.filter(rule => rule.accounts.type === 'accumulation'),
  PENSION: Rules.filter(rule => rule.accounts.type === 'pension'),
};

export default {
  paymentInstructionMatrix,
  accountTypes,
};
